<template>
  <div class="input-media" v-if="value">

    <span @click="dialogVisible = true">
      <small v-if="!selectedMedium && value.linkId">Attention le média précedemment inséré n'existe plus.</small>
      <img v-if="selectedMedium" class="image" :src="selectedMedium.url" alt="">
      <span class="add" v-else>Ajouter une image</span>
    </span>

    <el-dialog title="Choisir un media" :visible.sync="dialogVisible" @open="fetchData()">
      <ul class="pagination" v-if="this.media">
        <li v-if="this.page > 1" @click="page = page - 1">&lt;</li>
        <li v-if="this.page > 1" @click="page = page - 1">{{ this.page - 1 }}</li>
        <li class="current">{{ this.page }}</li>
        <li v-if="this.media.length > this.page * this.itemsByPage" @click="page = page + 1">{{ this.page + 1 }}</li>
        <li v-if="this.media.length > this.page * this.itemsByPage" @click="page = page + 1">&gt;</li>
      </ul>

      <el-upload ref="upload"
          class="input-upload-demo"
          :show-file-list="false"
          :action="uploadUrl"
          :headers="headers"
          :data="{ name: 'Media', description: ' ' }"
          :on-success="uploaded"
          :on-error="errorUpload"
          :auto-upload="true">
          <el-button slot="trigger" size="small" type="primary">Ajouter un nouveau média</el-button>
        </el-upload>

      <span v-for="medium in slicedMedia" :key="medium.mediaId"
        :class="{ active: (value.linkId || null) === medium.mediaId }"
        @click="select(medium.mediaId)">
        <img class="image" :src="medium.url" alt="">
      </span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Fermer</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/services/api';
import auth from '@/services/auth';

export default {
  name: 'input-media',
  props: ['value', 'open'],
  data() {
    return {
      selectedMedium: null,
      slicedMedia: null,
      media: null,
      dialogVisible: false,
      page: 1,
      itemsByPage: 6,

      uploadUrl: '',
      headers: {},
    };
  },
  async mounted() {
    await this.fetchData();
    this.uploadUrl = api.getUploadMediaUrl(this.$route.params.spaceId);
    this.headers.Authorization = auth.getAuthorizationHeader();
  },
  watch: {
    open: 'checkOpen',
    value: 'fetchData',
    page: 'paginate',
  },
  methods: {
    async fetchData() {
      this.media = await api.getMedia(this.$route.params.spaceId);
      this.paginate();
      if (this.value) this.selectedMedium = this.media.find(m => m.mediaId === this.value.linkId || null);
      if (this.open) this.checkOpen();
    },
    paginate() {
      this.slicedMedia = this.media.slice((this.page - 1) * this.itemsByPage, this.page * this.itemsByPage);
    },
    checkOpen() {
      this.dialogVisible = !!this.open;
    },
    select(id) {
      this.selectedMedium = this.media.find(m => m.mediaId === id);

      this.$emit('input', {
        type: 'Media',
        spaceId: this.$route.params.spaceId,
        linkId: id,
      });
      this.dialogVisible = false;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    errorUpload() {
      this.$message({
        type: 'info',
        message: 'Upload impossible, veuillez réussir plus tard.',
      });
    },
    uploaded(response) {
      if (response) {
        this.$notify.success({
          title: 'Upload réussi',
          message: 'Média uploadé avec succès',
        });
        this.fetchData();
      }
    },
  },
};
</script>

<style lang="sass">
.input-media
  position: relative
  min-height: 200px
  > span
    cursor: pointer
    small
      display: block
      padding: 1rem 0 1.5rem
      color: #aaaaaa
  .el-dialog__body
    max-height: 80vh
    overflow-y: scroll
    span
      display: inline-block
      padding: 0.5rem
      .image
        width: 200px
  .image
    display: inline-block
    max-width: 650px
    height: 200px
    object-fit: contain
    border: 1px solid #eaeaea
    background: #FAFAFA url('data:image/svg+xml, <svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" fill-opacity=".1" ><rect x="200" width="200" height="200" /><rect y="200" width="200" height="200" /></svg>')
    background-size: 10px 10px
  .active
    display: inline-block
    border: 3px solid red
    border-radius: 2px

  .input-upload-demo
    position: absolute
    top: 12px
    right: 50px
    .el-button--primary.el-button--small
      padding: 5px 0
      background: #ff5050
      border: 0

  .pagination
    position: absolute
    top: 2px
    left: 130px
    li
      display: inline-block
      margin: 0.1rem
      padding: 0.4rem 0.6rem
      list-style-type: none
      font-size: 0.8rem
      background: #FAFAFA
      border-radius: 50%
      cursor: pointer
      &.current
        color: #ff5050
</style>
